/**
 * Kayıtlı kolon sırasına, kaydedildikten sonra eklenmiş kolonları varsayılan yerlerine yerleştirir.
 *
 * TanStack sırada olmayan kolonu en sona koyar; tabloya yeni kolon eklendiğinde (ör. Canlı
 * Tartım'a "İçeride kalma") düzenini kaydetmiş kullanıcıda kolon tablonun sonuna düşüyordu.
 * Yeni kolon, varsayılan sırada kendinden önce gelen ve kayıtlı sırada bulunan kolonun hemen
 * arkasına girer; öyle bir kolon yoksa başa. Kayıtlı sıra boşsa (düzen hiç kaydedilmemiş)
 * olduğu gibi döner: varsayılan sıra zaten geçerlidir. Artık var olmayan kayıtlı kimlikler
 * TanStack tarafından yok sayılır, burada dokunulmaz.
 */
export function mergeColumnOrder(saved: string[], defaults: string[]): string[] {
  if (saved.length === 0) return saved
  const present = new Set(saved)
  const missing = defaults.filter((id) => !present.has(id))
  if (missing.length === 0) return saved

  const order = [...saved]
  for (const id of missing) {
    const index = defaults.indexOf(id)
    const anchor = defaults
      .slice(0, index)
      .reverse()
      .find((previous) => order.includes(previous))
    order.splice(anchor === undefined ? 0 : order.indexOf(anchor) + 1, 0, id)
  }
  return order
}
